// extracted by mini-css-extract-plugin
export default {"parking":"App_parking__O2qch"};